/**
 * @generated SignedSource<<ecf601b77006ef5bb8b4a6882e2defae>>
 * @relayHash e20833603f55baf33c05d488de093039
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 051a217822c4ed932215d5dd2b311bc3f2cbc59380ffd0c24208e2de834610ee

import type { ConcreteRequest, Query } from 'relay-runtime';
export type BillingSourceSystem = "CCP" | "HAMS" | "%future added value";
export type useIsEligibleForAiInEditorQuery$variables = {
  cloudId: string;
};
export type useIsEligibleForAiInEditorQuery$data = {
  readonly license: {
    readonly billingSourceSystem: BillingSourceSystem | null | undefined;
  } | null | undefined;
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly experienceCapabilities: {
          readonly changeOfferingV2: {
            readonly experienceUrl: string | null | undefined;
            readonly isAvailableToUser: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly transactionAccount: {
          readonly isBillToPresent: boolean | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type useIsEligibleForAiInEditorQuery = {
  response: useIsEligibleForAiInEditorQuery$data;
  variables: useIsEligibleForAiInEditorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = {
  "concreteType": "License",
  "kind": "LinkedField",
  "name": "license",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "billingSourceSystem"
    }
  ]
},
v2 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "hamsProductKey",
    "value": "confluence.ondemand"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "isBillToPresent"
},
v5 = [
  {
    "kind": "Literal",
    "name": "offeringName",
    "value": "Premium"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "isAvailableToUser"
},
v7 = {
  "kind": "ScalarField",
  "name": "experienceUrl"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useIsEligibleForAiInEditorQuery",
    "selections": [
      (v1/*: any*/),
      {
        "args": (v2/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "transactionAccount",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      {
                        "args": (v5/*: any*/),
                        "kind": "LinkedField",
                        "name": "changeOfferingV2",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                      }
                    ]
                  }
                ]
              }
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useIsEligibleForAiInEditorQuery",
    "selections": [
      (v1/*: any*/),
      {
        "args": (v2/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "transactionAccount",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "args": (v5/*: any*/),
                        "kind": "LinkedField",
                        "name": "changeOfferingV2",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                      }
                    ]
                  },
                  (v9/*: any*/)
                ]
              }
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "e20833603f55baf33c05d488de093039",
    "id": "051a217822c4ed932215d5dd2b311bc3f2cbc59380ffd0c24208e2de834610ee",
    "metadata": {},
    "name": "useIsEligibleForAiInEditorQuery",
    "operationKind": "query",
    "text": "query useIsEligibleForAiInEditorQuery($cloudId:ID!){license{billingSourceSystem},tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:\"confluence.ondemand\"){__typename,entitlement{__typename,transactionAccount{__typename,isBillToPresent,...on Node{__isNode:__typename,id}},experienceCapabilities{__typename,changeOfferingV2(offeringName:\"Premium\"){__typename,isAvailableToUser,experienceUrl}},id}}}}"
  }
};
})();

(node as any).hash = "0d75dc71c4b33da642ee318f10fa7971";

export default node;
